import * as React from "react";
import LockIcon from "@material-ui/icons/Lock";
import LinkIcon from "@material-ui/icons/Link";
import IconButton from "@material-ui/core/IconButton";
import { CaseFormType, DETAIL_PATH, INCIDENT_DETAIL_PATH } from "../../../constants/api";
import { Link } from "react-router-dom";

class CaseNoComponent extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
  }

  public render() {
    const value = this.props.dataItem[this.props.field];
    const uniqueId = this.props.dataItem.uniqueId;
    const pathComponents = [];
    switch (this.props.dataItem["caseFormType"]) {
      case CaseFormType.Incident:
        pathComponents.push(INCIDENT_DETAIL_PATH);
        pathComponents.push(uniqueId);
        pathComponents.push("incident-mainform");
        break;

      case CaseFormType.WarehouseNonConformity:
        pathComponents.push(DETAIL_PATH);
        pathComponents.push(uniqueId);
        pathComponents.push("wh-nonconformity-mainform");
        break;

      default:
        pathComponents.push(DETAIL_PATH);
        pathComponents.push(uniqueId);
        pathComponents.push("mainform");
        break;
    }
    const path = pathComponents.join("/");
    const { isLocked } = this.props;
    return (
      <td>
        <Link to={path}>{value}</Link>
        <span title="Open Case in New Tab">
          <IconButton
            color="primary"
            onClick={this.goToNewTab.bind(this, path)}
          >
            <LinkIcon />
          </IconButton>
        </span>
        {isLocked ? (
          <span>
            <LockIcon />
          </span>
        ) : (
          <span />
        )}
      </td>
    );
  }

  private goToNewTab = (value: any, event: any) => {
    window.open(value, "_blank");
  };
}

export default CaseNoComponent;
